import React from 'react';

// Shared summary-stat strip used at the top of the receipt pages.
// Each page passes its own metrics; the style is identical everywhere.
export interface Stat {
  label: string;
  value: number;
  accent?: boolean;
}

function StatItem({ label, value, accent }: Stat) {
  return (
    <div className="flex items-baseline gap-1.5">
      <span className={`text-base font-bold leading-none ${accent ? 'text-teal-600' : 'text-ink'}`}>{value.toLocaleString()}</span>
      <span className="text-xs text-muted uppercase tracking-wide">{label}</span>
    </div>
  );
}

// Inline stat figures, right-anchored in the header bar. No card chrome — the
// numbers sit directly on the band so the row reads as one sleek toolbar.
export function StatBanner({ stats }: { stats: Stat[] }) {
  return (
    <div className="flex items-center gap-3">
      <span className="text-xs font-semibold uppercase tracking-wide text-copy">Stats</span>
      {stats.map((s, i) => (
        <React.Fragment key={s.label}>
          {i > 0 && <div className="w-px h-4 bg-trim" />}
          <StatItem {...s} />
        </React.Fragment>
      ))}
    </div>
  );
}
